import { render, staticRenderFns } from "./PlatformTooltip.vue?vue&type=template&id=75318323"
import script from "./PlatformTooltip.vue?vue&type=script&lang=ts"
export * from "./PlatformTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports